import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from './Login';
import RegisterForm from './Register';
import Department from './department';
import MetabolismForm from './departments/metabolism';
import ObeseForm from './departments/obesity';
import CaseReview from './departments/CaseReview';
import DoctorPortal from './departments/DoctorPortal';
import RoleSlider from './departments/RoleSlider';
import ConsultationPrompt from './departments/ConsultationPrompt';
import StudentForm from './StudentForm';
//import TempTest from './TempTest'
import PrivateRoute from './PrivateRoute';
import RecordingButton from './RecordingButton';
import MetabolismWordCloud from './metabolismwordcloud';
import ObeseWordCloud from './obeseworcloud';
import VoiceRecordingConsentForm from './ConsentForm';
import AdminDashboard from './AdminDashboard';      // ← NEW
import ReportDashboard from './departments/ReportDashboard';
import { ToastContainer } from 'react-toastify';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

function Index() {
  const [userName, setUserName] = useState('');
  const [qrCode, setQrCode] = useState('');

  const hostname = window.location.hostname;

  const isSubdomain =
    hostname.startsWith('consult.') || hostname.startsWith('test.') || hostname === 'localhost';

  const isMainDomain =
    hostname === 'conversationaily.ai' ||
    hostname === 'testone.conversationaily.ai' ||
    hostname === 'localhost';

  useEffect(() => {
    const storedUserName = localStorage.getItem('userName');
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {isSubdomain ? (
          <>
            {/* <Route path="/" element={<DoctorPortal />} />  */}
            <Route path="/" element={<Login setUserName={setUserName} setQrCode={setQrCode} />} />
            <Route
              path="/forgot-password"
              element={<ForgotPassword />}
            />

            <Route
              path="/reset-password"
              element={<ResetPassword />}
            />


            <Route path="/register" element={<StudentForm />} />
            {/* <Route path="/temp_test" element={<TempTest />} />   */}
            <Route path="/consultation" element={<ConsultationPrompt name={userName} />} />
            <Route path="/cases" element={<RoleSlider name={userName} />} />
            <Route path="/reports" element={<ReportDashboard name={userName} />} />

            <Route path="/casereview" element={
              <PrivateRoute>
                <CaseReview name={userName} />
              </PrivateRoute>
            } />
            {/* ── Admin dashboard — PIN protected, no JWT needed ── */}
            <Route path="/admin" element={<AdminDashboard />} />  {/* ← NEW */}
          </>
        ) : isMainDomain ? (
          <>
            <Route path="/" element={<Login setUserName={setUserName} setQrCode={setQrCode} />} />
            <Route path="/login" element={<Login setUserName={setUserName} setQrCode={setQrCode} />} />
            <Route path="/register" element={<RegisterForm />} />

            <Route path="/department" element={
              <PrivateRoute>
                <Department name={userName} />
              </PrivateRoute>
            } />
            <Route path="/metabolism" element={
              <PrivateRoute>
                <MetabolismForm name={userName} />
              </PrivateRoute>
            } />
            <Route path="/obesity" element={
              <PrivateRoute>
                <ObeseForm name={userName} />
              </PrivateRoute>
            } />
            <Route path="/recording" element={
              <PrivateRoute>
                <RecordingButton name={userName} />
              </PrivateRoute>
            } />
            <Route path="/metabolismwordcloud" element={
              <PrivateRoute>
                <MetabolismWordCloud name={userName} />
              </PrivateRoute>
            } />
            <Route path="/obesewordcloud" element={
              <PrivateRoute>
                <ObeseWordCloud name={userName} />
              </PrivateRoute>
            } />
            <Route path="/consent" element={
              <PrivateRoute>
                <VoiceRecordingConsentForm name={userName} />
              </PrivateRoute>
            } />
            <Route path="/consent/:id" element={
              <PrivateRoute>
                <VoiceRecordingConsentForm name={userName} />
              </PrivateRoute>
            } />
            <Route path="/feedback" element={
              <PrivateRoute>
                <VoiceRecordingConsentForm name={userName} />
              </PrivateRoute>
            } />
          </>
        ) : (
          <Route path="*" element={<div>Domain not supported.</div>} />
        )}
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Index />
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnHover
    />
  </React.StrictMode>
);